import { Icon, IconName, MenuAction } from "@inductiveautomation/ws-components";
import { TFunction } from "i18next";
import { ReactElement } from "react";
import {
  CertificationActionCallback,
  CertificationLinkAction,
  CertificationType,
} from "./Training.types";

// TODO: rework this when we allow downloads
export const downloadActions = (
  t: TFunction,
  onAction: CertificationActionCallback
): MenuAction[] => [
  {
    id: "download-badge",
    label: t("training.actions.download_badge"),
    onClick: () => onAction("download-badge"),
    iconLeft: "download",
  },
  {
    id: "download-certificate",
    label: t("training.actions.download_certificate"),
    onClick: () => onAction("download-certificate"),
    iconLeft: "download",
  },
];

export const visitInductiveUniversityAction = (
  t: TFunction,
  onClick: () => void
): MenuAction & { icon: IconName } => ({
  id: "visit-inductive-university",
  label: t("training.actions.visit_inductive_university"),
  onClick,
  iconLeft: "iu",
  iconRight: "open-small",
  iconRightVariant: "neutralLight",
  icon: "open-small",
});

export const visitInductiveUniversityUpdatedAction = (
  t: TFunction,
  onClick: () => void
): MenuAction & { icon: IconName } => ({
  ...visitInductiveUniversityAction(t, onClick),
  icon: "open-small",
  chipLabel: "NEW",
  chipState: "primary",
});

export const purchaseTestAction = (
  t: TFunction,
  onAction: CertificationActionCallback,
  certificationPurchaseType: CertificationType
): MenuAction & { icon: IconName | undefined } => ({
  id: "purchase-test",
  label: t("training.actions.purchase_test.label"),
  onClick: () => onAction("purchase-test", { certificationPurchaseType }),
  iconLeft: "test-outlined",
  icon: undefined,
});

export const unearnedCertificationActions = (
  t: TFunction,
  onAction: CertificationActionCallback,
  certificationPurchaseType: CertificationType
) => {
  return [[purchaseTestAction(t, onAction, certificationPurchaseType)]];
};

export const goldLearnMore = (
  t: TFunction,
  onClick: () => void
): MenuAction & { icon: IconName } => ({
  id: "learn-more-about-gold-tests",
  label: t("training.actions.learn_more_about_gold_tests"),
  onClick,
  iconLeft: "inverted-info",
  iconRight: "open-small",
  iconRightVariant: "neutralLight",
  icon: "open-small",
});

export const submitTestAction = (
  t: TFunction,
  onClick: () => void,
  resubmit = false
): MenuAction & {
  icon: ReactElement;
} => ({
  id: "submit-test",
  label: resubmit
    ? t("training.actions.resubmit_test")
    : t("training.actions.submit_test.label"),
  onClick,
  iconLeft: "test-outlined" as const,
  iconRight: "open-small" as const,
  iconRightVariant: "neutralLight" as const,
  icon: <Icon name="open" />,
});

export const urlForAction: Record<CertificationLinkAction, string> = {
  "visit-inductive-university": "https://inductiveuniversity.com/",
  "view-training-schedule": "https://inductiveautomation.com/training/",
  "view-core-study-guide":
    "https://training.inductiveautomation.com/core-certification/study-guide/",
  "view-gold-study-guide":
    "https://training.inductiveautomation.com/gold-certification/study-guide/",
  "learn-more-about-gold-tests":
    "https://inductiveautomation.com/training/classes-and-certification",
  "submit-test": "https://inductiveautomation.com/training/upload",
};
